import { FinnairPassengerServiceSelectionItem } from '../api/models';
import { GroupedServices } from '../interfaces';

const getKeyAndIconForService = (
  service: FinnairPassengerServiceSelectionItem,
  showAsPending = false
): Omit<GroupedServices, 'services'> => {
  const key = showAsPending
    ? 'pending'
    : service.includedInTierBenefit
    ? 'tier'
    : service.ticketed || service.includedInTicketType
    ? 'ticket'
    : 'unpaid';
  const icon = showAsPending
    ? 'save-time'
    : service.includedInTierBenefit
    ? 'finnair-plus'
    : service.ticketed || service.includedInTicketType
    ? 'checkmark'
    : 'shopping-cart';

  return { key, icon };
};

export const getGroupedServices = (
  services: FinnairPassengerServiceSelectionItem[] = [],
  showAsPending = false
): GroupedServices[] => {
  return services
    .reduce((all, service: FinnairPassengerServiceSelectionItem) => {
      const oldService = all
        .flatMap((group) => group.services)
        .find(
          (s) =>
            s.variant === service.variant &&
            s.parameters?.baggageWeight === service.parameters?.baggageWeight &&
            s.totalPrice?.amount === service.totalPrice?.amount &&
            s.ticketed === service.ticketed
        );
      if (oldService) {
        oldService.quantity += service.quantity;
      } else {
        const { key, icon } = getKeyAndIconForService(service, showAsPending);
        const group = all.find((c) => c.key === key);
        if (!group) {
          all.push({
            key,
            icon,
            services: [{ ...service }],
          });
        } else {
          group.services.push({ ...service });
        }
      }
      return all;
    }, [] as GroupedServices[])
    .sort((a, b) => {
      const sortIds = {
        ticket: 3,
        tier: 2,
        unpaid: 1,
      };
      return sortIds[b.key] - sortIds[a.key];
    });
};
